var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileAdd = function SvgFileAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12a.5.5 0 0 1 .5.5V14h1.5a.5.5 0 0 1 0 1H18v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H17v-1.5a.5.5 0 0 1 .5-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10.758V6.414a1 1 0 0 0-.293-.707l-3.414-3.414A1 1 0 0 0 15.586 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1.758a4.5 4.5 0 0 0 2-3.742c0-1.56-.794-2.935-2-3.742m-1-4.344L15.586 3H15.5v3.5a.5.5 0 0 0 .5.5h3zM19 8h-3a1.5 1.5 0 0 1-1.5-1.5V3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.256a4.5 4.5 0 1 1 0-8.488zm-1.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
    clipRule: "evenodd"
  })));
};
export default SvgFileAdd;